/*
 * File: ZoomInfo.tsx
 * Project: a-a
 * File Created: Thursday, 23rd October 2025 9:54:13 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 23rd October 2025 10:15:47 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import ZoomInfoHome from '../../components/featured/ZoomInfo/ZoomInfoHome';

const ZoomInfo = () => {
  return (
    <div>
      <ZoomInfoHome />
    </div>
  );
};

export default ZoomInfo;
